/**
 * Data FAQ untuk halaman About
 */
export const faqs = [
  {
    question: "Apa itu sistem rekomendasi?",
    answer:
      "Sistem rekomendasi adalah sistem yang digunakan untuk memberikan saran atau rekomendasi kepada pengguna berdasarkan data yang tersedia, seperti preferensi atau perilaku pengguna.",
  },
  {
    question: "Bagaimana cara kerja Collaborative Filtering?",
    answer:
      "Collaborative Filtering bekerja dengan menganalisis pola preferensi pengguna dan memberikan rekomendasi berdasarkan kemiripan antara pengguna atau item.",
  },
  {
    question: "Apa yang dimaksud dengan Memory-Based Filtering?",
    answer:
      "Memory-Based Filtering adalah metode yang mengandalkan data historis untuk memberikan rekomendasi, seperti User-Based dan Item-Based Collaborative Filtering.",
  },
  {
    question:
      "Apa kelebihan sistem rekomendasi berbasis collaborative filtering?",
    answer:
      "Sistem berbasis Collaborative Filtering dapat memberikan rekomendasi yang lebih relevan dengan mengandalkan interaksi antar pengguna dan item tanpa memerlukan informasi tentang item itu sendiri.",
  },
];
